import { getAxios } from '../../../../lib/axios';
import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { useMutation } from '@tanstack/react-query';
import { TravellerSearchForm } from '../utils/types';

export const useActivityInformationTravellerSearch = () => {
  return useMutation({
    mutationFn: async (vars: { model: Partial<TravellerSearchForm> }) => {
      return await getAxios().post<Array<number>>(ActivityEndpoints.information.travellerSearch, vars.model);
    }
  });
};
